import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NeverBounceService {
  private scriptLoaded = false;
  private scriptLoadingPromise: Promise<void>;

  loadScript(): Promise<void> {
    if ((window as any).NeverBounceWidget) {
      return Promise.resolve();
    }

    if (this.scriptLoadingPromise) {
      return this.scriptLoadingPromise;
    }

    this.scriptLoadingPromise = new Promise((resolve, reject) => {
      const scriptId = 'neverbounce-widget-script';
      if (document.getElementById(scriptId)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://cdn.neverbounce.com/widget/dist/NeverBounce.js';
      script.async = true;
      script.onload = () => {
        console.log('✅ NeverBounce script loaded');
        resolve();
      };
      script.onerror = () => reject('Failed to load NeverBounce script');

      document.body.appendChild(script);
    });

    return this.scriptLoadingPromise;
  }
  
  async validateInput(input: HTMLInputElement): Promise<void> {
    if (!input || !input.id) {
      console.warn('⚠️ Input element is missing or does not have an ID.');
      return;
    }

    await this.loadScript();

    // Wait 200ms to give script time to fully register
    await new Promise(res => setTimeout(res, 1000));

    const widget = await this.pollForWidget();

    if (!widget) {
      throw new Error('NeverBounceWidget is not available even after loading.');
    }

    widget.init(input.id, (result: any) => {
      if (result.result !== 'valid') {
        input.setCustomValidity('Invalid email');
      } else {
        input.setCustomValidity('');
      }
    });
  }
  

  async pollForWidget(): Promise<any> {
    const maxAttempts = 10;
    let attempts = 0;

    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        if ((window as any).NeverBounceWidget) {
          clearInterval(interval);
          resolve((window as any).NeverBounceWidget);
        } else if (++attempts >= maxAttempts) {
          clearInterval(interval);
          console.error('❌ NeverBounceWidget still not available after retries.');
          reject(new Error('NeverBounceWidget still not available after retries.'));
        }
      }, 300);
    });
  }


}
